export default "__VITE_ASSET__BjA68zOF__"